import {
    EntitySetName,
    IPrHealthInsuranceCompanyEntity,
    PrHealthInsuranceCompanyBankAccountEntity,
    PrHealthInsuranceCompanyEntity
} from "@odata/GeneratedEntityTypes";
import { memoizedWithCacheStrategy } from "@utils/CacheCleaner";

import { IAppContext } from "../../../contexts/appContext/AppContext.types";
import { CacheStrategy } from "../../../enums";
import { Model } from "../../../model/Model";

interface ILoadIPrHealthInsuranceCompanyArgs {
    storage: Model;
    context: IAppContext;
}

export async function loadHealthInsuranceCompanies({ storage }: ILoadIPrHealthInsuranceCompanyArgs): Promise<IPrHealthInsuranceCompanyEntity[]> {
    const result = await storage.oData
            .getEntitySetWrapper(EntitySetName.PrHealthInsuranceCompanies)
            .query()
            .expand(PrHealthInsuranceCompanyEntity.BankAccounts, q => q.expand(PrHealthInsuranceCompanyBankAccountEntity.Region))
            .fetchData<IPrHealthInsuranceCompanyEntity[]>();

    return result?.value ?? [];
}

export const getHealthInsuranceCompaniesMemoized = memoizedWithCacheStrategy<ILoadIPrHealthInsuranceCompanyArgs, IPrHealthInsuranceCompanyEntity[]>(loadHealthInsuranceCompanies, () => null);

export async function loadHealthInsuranceCompaniesMemoized(args: ILoadIPrHealthInsuranceCompanyArgs): Promise<IPrHealthInsuranceCompanyEntity[]> {
    return getHealthInsuranceCompaniesMemoized(args, CacheStrategy.EndOfTime);
}